// extracted by mini-css-extract-plugin
module.exports = {"invalidText":"styles_invalidText__1JzOH","customFormGroup":"styles_customFormGroup__10DoF"};